import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import MuiDialogAlert from '../components/MuiDialogAlert';
import LoadingOverlay from 'react-loading-overlay';




import { useUserAuth } from "../context/UserAuthContext";

const axios = require('axios').default;

function Login(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loadingActive, setLoadingActive] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState("Logging In ...");

  const [modalBody, setModalBody] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalHeader, setModalHeader] = useState("");
  
  const [disableLoginBtn, setDisableLoginBtn] = useState(true);

  const handleClose = () => setShowModal(false);

  const { logIn } = useUserAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (email != "" && password != ""){
      setDisableLoginBtn(false);
    }
    else{
      setDisableLoginBtn(true);
    }
    
  }, [email,password])
  



  function handleKeypress(e){
    //it triggers by pressing the enter 
    if (e.charCode === 13) {
      processLogin(e);
    }
  };



  async function processLogin(e){
    //e.preventDefault();
    
    try{
      let login_info
      setLoadingActive(true);
      login_info = await logIn(email, password);

      let user = {};
      user.accessToken = login_info.user.accessToken
      user.email = login_info.user.email
      user.uid = login_info.user.uid

      let url = process.env.REACT_APP_API_SERVER + "/login";

      axios.post(url, {
        "email": login_info.user.email,
        "accessToken": login_info.user.accessToken,
        "uid": login_info.user.uid
      })
        .then(function (response) {
          localStorage.setItem('user', JSON.stringify(user));
          navigate("/RoomActivity");
        })
        .catch(function (error) {
          console.log(error);
          setLoadingActive(false);

        });
    }
    catch(err){
      setModalHeader("Unable to Login")
      let err_msg = ""
      if (err.message == "Firebase: Error (auth/internal-error)." || err.message == "Firebase: Error (auth/wrong-password).") {
        err_msg = "Your email or password is incorrect."
      } else {
        err_msg = err.message
      }
      setModalBody(err_msg);
      setShowModal(true);
      setLoadingActive(false);
    }

  }

  return (
    <div align="center" style={{height: "100vh"}}>

      <LoadingOverlay
        active={loadingActive}
        spinner
        text={loadingMsg}
        className="spinner_div"
      >

        <div align="center" className='title_header'>LOGIN</div>
        <div style={{ width: "500px" }}>
        <div style={{ height: "30px" }}></div>



            <TextField
              id="username"
              onChange={(e) => setEmail(e.target.value)}
              variant="outlined"
              value={email}
              label="Username"
              onKeyPress={handleKeypress}

            />

            <div style={{ height: "10px" }}></div>

            <TextField
              id="password"
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
              value={password}
              label="Password"
              onKeyPress={handleKeypress}
            />

            <div style={{ height: "30px" }}></div>
            <div>
              <Button
                variant="contained"
                color="success"
                onClick={processLogin}
                disabled={disableLoginBtn}
                sx={{ width: 200, height: 50 }}
              >
                LOGIN
              </Button>
            </div>

          <div style={{ height: "10px" }}></div>

          <div><a href="/reset_password">Forgot Password</a></div>


          <MuiDialogAlert
            showModal={showModal}
            handleClose={handleClose}
            bodyContent={modalBody}
            title={modalHeader}
            bodyClass="whitespace"
          />


        </div>

      </LoadingOverlay>




    </div>
  )
}

export default Login